<app-loading-screen *ngIf="isLoading">Loading Premiums</app-loading-screen>
<app-loading-screen *ngIf="isDownloading">Downloading File</app-loading-screen>
<div *ngIf="!isReadOnly" class="right-flex">
    <app-button size="medium" buttonType="primary" (click)="UpdatePremiumdetails()" (keydown)="UpdatePremiumdetails()" style="margin-right: 15px;">
        Save Data
    </app-button>
    <a *ngIf="isAdmin" 
    class="clearButton interactive-links covert-to-thousand-button"
    (click)="convertTothousandsButtonClick()">Convert To 1,000s</a>
    <a class="clearButton interactive-links" (click)="Clear()">Clear</a>
</div>
<div *ngIf="!isReadOnlyAdmin && isLockForValidation" class="right-flex">
    <app-button (click)="clickToUnLock()" (keydown)="clickToUnLock()" size="medium" type="button" buttonType="primary">
      <mat-icon class="unlock-icon">lock_open</mat-icon>
      Unlock To Edit
    </app-button>
</div>
<div class="pagetitle">Premium Report: User Defined Data: {{ currentYear }}</div>
<div *ngIf="compno!==null">
    <span class="pagetitleSecondLayerBold"> {{ prfNumber }} </span>:<span class="pagetitleSecondLayer">
        {{ prfName }}</span>
</div>
<div class="page-description">
    <i class="material-icons note-icon">info</i>
    <span class="note-text">
        This tab is used to carve out specific programs that are Non-ISO, 
        or if you want to carve out some of your premiums with a more specific description.
    </span>
</div>
<hr class="horizontalRule" />


<div class="noteB" style="display: inline-block; ">Note: Dollar amounts represented as thousands of dollars.</div>
<div *ngIf="!isReadOnly" class="downloadButton">
    <button *ngIf="!isReadOnly" (click)="openUploadPremium()" class="interactive-links exitFS">
        <i class="table-material-icons">publish</i> Upload Data
    </button>
    <button *ngIf="!isReadOnly" (click)="openuserdefinedcols()" class="interactive-links exitFS">
        <i class="table-material-icons">view_column</i> Manage Columns
    </button>
    <button 
        [ngClass]="{'disabled': !hasUserDefinedCols}" 
        [disabled]="!hasUserDefinedCols"
        (click)="downloadtemplate()" 
        class="interactive-links">
        <i class="table-material-icons">get_app</i> Download Template
    </button>
</div>
<div class="PageLevelError" *ngIf="showPageError">{{ errorMsg }}</div>
<div class="PageLevelWarning" *ngIf="showPageWarning">{{ warningMsg }}</div>
<div class="grid__menu">
    <span class="lblCellName">{{cellName}}</span>
    <span class="lblCellName">{{cellFormula}}</span>
</div>

<div id="grid-container">
    <div class="gridheader">
        <div class="tab">
            <button class="tablinks active interactive-links" (click)="showtab('direct')">{{ 'premium.directPlural' | label }}</button>
            <button class="tablinks interactive-links" (click)="showtab('supplemental')">{{ 'premium.supplementalPlural' | label }}</button>
        </div>
        <div class="flex-item flex-grow"></div>
        <div class="action horizontal-flex-container">
            
            <button (click)="openDownloadPremium()" class="interactive-links exitFS">
                <i class="table-material-icons">get_app</i> Download Data
            </button>
            <button (click)="downloadData(true)" class="interactive-links exitFS">
                <img src="../../../assets/img/pdf.png" alt="" /> Generate PDF
            </button>
            <button
                *ngIf="!isFullscreen"
                (click)="openFullscreen()"
                class="bottom"
                ngbTooltip="View&nbsp;full&nbsp;screen"
                placement="bottom"
            >
                <i class="table-material-icons fs-20">fullscreen</i>
            </button>
            <button
                *ngIf="isFullscreen"
                (click)="exitFullscreen()"
                class="left"
                ngbTooltip="Exit&nbsp;full&nbsp;screen"
                placement="left"
            >
                <i class="table-material-icons fs-20 fs-position" >exit_fullscreen</i>
            </button>
        </div>
    </div>
    <div class="igx-grid-container"
        [ngClass]="{
            'fullscreen-active': isFullscreen,
            'default-view': !isFullscreen
        }"
        (clickOutside)="onClickedOutside($event)"
    >
        <igx-grid igxPreventDocumentScroll #grid1 [data]="premium_info" [autoGenerate]="false"
            [rowEditable]="false" paste-handler
            (onDataProcessed)="updateRecords($event)" [primaryKey]="'0'" [clipboardOptions]="options"
            (cellEditEnter)="editStart($event)" (cellEditDone)="onEditCompleted($event)"
            (selected)="onCellSelect($event)" [emptyGridMessage]="'.'" (gridKeydown)="enterGridEditMode($event)"
            (keydown)="enterEditMode($event)"
            [ngClass]="{'igx-grid-fs': isFullscreen}"
        >

            <igx-column *ngFor="let c of udcolumns" [field]="c.columnNumber.toString()" [header]="c.columnName" [pinned]="c.IsPinned"
                [cellClasses]="cellClass" [editable]="isReadOnly == true ? false : c.editable"
                [width]="getColWidth(c.columnNumber)" [dataType]="c.dataType" [resizable]="true">
                <ng-template igxHeader let-column>
                    <div>
                        {{ column.header | modifyHeader }}
                    </div>
                </ng-template>
                <ng-template igxCellEditor let-cell="cell">
                    <igx-input-group>
                        <input igxInput [igxFocus]="true" (focus)="onCellFocus($event)" [(ngModel)]="cell.editValue"
                        class="input-selection" type="number" id="input" [ngClass]="{'no-spinners': true}" />
                    </igx-input-group>
                </ng-template>
            </igx-column>
        </igx-grid>
        <div id="direct" style="width: 100%"> </div>
        <div id="supplemental"> </div>
    </div>
    <app-confirm-dialog></app-confirm-dialog>
    <app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
</div>
<div class="note" style="display: inline-block">
    <span class="noteTitle">Note:</span> Use Ctrl+X/Ctrl+C/Ctrl+V for Cut/Copy/Paste operations
</div>
